import { render, staticRenderFns } from "./c_checkbox_group.vue?vue&type=template&id=d6f15e90&scoped=true"
import script from "./c_checkbox_group.vue?vue&type=script&lang=js"
export * from "./c_checkbox_group.vue?vue&type=script&lang=js"
import style0 from "./c_checkbox_group.vue?vue&type=style&index=0&id=d6f15e90&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f15e90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/mac/Documents/project/code/shop/zhongyijia-admin-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6f15e90')) {
      api.createRecord('d6f15e90', component.options)
    } else {
      api.reload('d6f15e90', component.options)
    }
    module.hot.accept("./c_checkbox_group.vue?vue&type=template&id=d6f15e90&scoped=true", function () {
      api.rerender('d6f15e90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfigRight/c_checkbox_group.vue"
export default component.exports